import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SelectionsService {

  constructor(private http: HttpClient) {
  }

  addSelection(payload: any) {
    return this.http.post('/api/selections/selection/', payload);
  }

  fetchSelections() {
    return this.http.get('/api/selections/selection/');
  }

  fetchSelectionsWithId(id: number) {
    return this.http.get(`/api/selections/selection/?id=${id}`);
  }

  findSelections(title) {
    return this.http.get(`/api/selections/selection/?title=${title}`);
  }

  fetchFiltered(payload: any) {
    return this.http.post('/api/datasource/filtered/', payload);
  }

  getSelection(id: number) {
    return this.http.get(`/api/selections/selection/${id}/`, {headers:{skip404: "true"}});
  }

  updateSelection(id: number, payload: any) {
    return this.http.patch(`/api/selections/selection/${id}/`, payload);
  }

  deleteSelection(id: number) {
    return this.http.delete(`/api/selections/selection/${id}/`);
  }

}
